export const ASPECT_RATIO = 9 / 16;
export const PREVIEW_MAX_DIMENSION = 1600;
export const CORNER_HANDLE_SIZE = 20;
export const CORNER_HANDLE_HIT_SIZE = 40;
export const EDGE_HANDLE_HIT_SIZE = 24;

export const getCanvasSizeForAspect = (width: number, height: number) => {
  if (!width || !height) {
    return { width: 0, height: 0 };
  }

  const containerAspect = width / height;
  if (containerAspect > ASPECT_RATIO) {
    const canvasHeight = height;
    return {
      width: canvasHeight * ASPECT_RATIO*1.5,
      height: canvasHeight*1.25,
    };
  }

  const canvasWidth = width;
  return {
    width: canvasWidth*1.5,
    height: canvasWidth / ASPECT_RATIO * 1.25,
  };
};

export const getImageFrame = (params: {
  canvasWidth: number;
  canvasHeight: number;
  naturalWidth: number;
  naturalHeight: number;
}) => {
  const imageAspect = params.naturalWidth / params.naturalHeight;
  const canvasAspect = params.canvasWidth / params.canvasHeight;
  let width = params.canvasWidth;
  let height = params.canvasHeight;
  let x = 0;
  let y = 0;

  if (imageAspect > canvasAspect) {
    height = width / imageAspect;
    y = (params.canvasHeight - height) / 2;
  } else {
    width = height * imageAspect;
    x = (params.canvasWidth - width) / 2;
  }

  return { x, y, width, height };
};

export const getScaleToPreview = (params: {
  canvasWidth: number;
  canvasHeight: number;
  naturalWidth: number;
  naturalHeight: number;
}) => {
  const imageAspect = params.naturalWidth / params.naturalHeight;
  const canvasAspect = params.canvasWidth / params.canvasHeight;
  let frameWidth = params.canvasWidth;
  let frameHeight = params.canvasHeight;

  if (imageAspect > canvasAspect) {
    frameHeight = frameWidth / imageAspect;
  } else {
    frameWidth = frameHeight * imageAspect;
  }

  return {
    scaleX: frameWidth / params.naturalWidth,
    scaleY: frameHeight / params.naturalHeight,
  };
};
